import { useCallback, useMemo, useState } from 'react';

import { useAttachmentUpload } from '@/features/DataChangeRequest/_hooks/useAttachmentUpload';
import type { DcrAttachment } from '@/features/DataChangeRequest/_types/attachment';

export const useInlineAttachments = (open: boolean) => {
	const [attachments, setAttachments] = useState<DcrAttachment[]>([]);

	const sessionId = useMemo(
		() => (open ? window.crypto.randomUUID() : ''),
		[open]
	);

	const { addFiles, removeAttachment } = useAttachmentUpload({
		attachments,
		onChange: setAttachments,
		sessionId
	});

	const discardAll = useCallback(() => {
		attachments.forEach(att => removeAttachment(att.id));
	}, [attachments, removeAttachment]);

	const clearLocal = useCallback(() => {
		setAttachments([]);
	}, []);

	const attachmentIds = useMemo(
		() =>
			attachments
				.filter(att => att.status === 'success' && !!att.remoteId)
				.map(att => att.remoteId as string),
		[attachments]
	);

	return {
		attachments,
		addFiles,
		removeAttachment,
		attachmentIds,
		discardAll,
		clearLocal,
		sessionId
	};
};
